import Hidden from "@material-ui/core/Hidden";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import OpenInBrowser from "@material-ui/icons/OpenInBrowser";
import clsx from "clsx";
import Link from "next/link";
import * as React from "react";
import Context from "../contexts";
var useStyles = makeStyles(function(theme) {
    return {
        alignRight: {
            textAlign: "right"
        },
        light: {
            color: theme.palette.getContrastText("#fff")
        },
        dark: {
            color: theme.palette.getContrastText(theme.palette.primary.main)
        },
        text: {
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            textTransform: "uppercase",
            overflow: "hidden",
            fontWeight: "bold",
            cursor: "pointer",
            ":& a": {
                textDecoration: "none",
                color: "white",
                cursor: "pointer"
            }
        },
        loggedInInfo: {
            lineHeight: "100%"
        },
        linkContainer: {
            display: "flex",
            alignItems: "center",
            "& > svg": {
                paddingRight: theme.spacing(0.5)
            }
        }
    };
});
var LineInfo = function(param) {
    var className = param.className, backgroundTone = param.backgroundTone, alignRight = param.alignRight, t = param.t;
    var tone = backgroundTone || "dark";
    var classes = useStyles();
    return /*#__PURE__*/ React.createElement(Context.LineDescription.Consumer, null, function(lineInfo) {
        if (lineInfo.lineDescription) {
            return /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(Typography, {
                variant: "body2",
                className: clsx(className, classes.loggedInInfo, classes[tone], classes.text, alignRight && classes.alignRight)
            }, /*#__PURE__*/ React.createElement(Link, {
                href: lineInfo.lineUrl
            }, /*#__PURE__*/ React.createElement(Tooltip, {
                title: t([
                    "shared:openLine"
                ], {
                    defaultValue: "Open line"
                })
            }, /*#__PURE__*/ React.createElement("span", {
                className: classes.linkContainer
            }, /*#__PURE__*/ React.createElement(OpenInBrowser, null), /*#__PURE__*/ React.createElement(Hidden, {
                smDown: true
            }, lineInfo.lineDescription))))));
        }
    });
};
export default LineInfo;
